import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var mutation = gql`
  mutation assignResourceToFormVersion($organizationId: UUID!, $templateId:  UUID!, $version: Int!, $resourceId:  UUID!) {
    assignResourceToFormVersion(organizationId: $organizationId, templateId: $templateId, version: $version, resourceId: $resourceId) {
      submission_id
      resource_id
      template_id
      version
      submitted_by_account_id
      created_ts
      updated_ts
    }
  }  
`;



export function apiAssignResourceToFormVersion(organizationId, templateId, version, resourceId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, templateId, version,resourceId},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.assignResourceToFormVersion);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to create template");
                reject(err); // R
            })
    });
}


